import React from 'react';
import { PopoverHeaderContainer, PopoverHeaderTitle } from './styles/popover-header.styled';
export const PopoverHeader = ({ title, children, dataTest, className }) => (React.createElement(PopoverHeaderContainer, { "data-test": dataTest, className: className },
    React.createElement(PopoverHeaderTitle, null, title),
    children));
PopoverHeader.POPOVER_ELEMENT = 'header';
//# sourceMappingURL=PopoverHeader.js.map